/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import qs from 'qs'

export type RedeemPromoCodeRequestProductType =
  (typeof RedeemPromoCodeRequestProductType)[keyof typeof RedeemPromoCodeRequestProductType]

export const RedeemPromoCodeRequestProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export interface RedeemPromoCodeRequest {
  promo_code_id: string
  product_type: RedeemPromoCodeRequestProductType
}

export interface RefereeSignupRequest {
  referrer_username: string
  campaign_identifier: string
  referee_email: string
  marketing_consent: boolean
  /** @nullable */
  referrer_link_sharing_source?: string | null
}

export interface BenefitPromotionCode {
  id: string
  code: string
  /** @nullable */
  expiry_date?: string | null
}

export interface RefereeSignupResponse {
  promo_code: BenefitPromotionCode
}

export type BenefitType = (typeof BenefitType)[keyof typeof BenefitType]

export const BenefitType = {
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
  FREE_MONTH: 'FREE_MONTH',
} as const

export interface CreateCampaignRequest {
  identifier: string
  /** @nullable */
  offer_discount_id?: string | null
  offer_discount_type: BenefitType
  offer_discount_amount: number
  reward_type: BenefitType
  reward_amount: number
  /** @nullable */
  reward_id?: string | null
  /** @nullable */
  coupon_expiry_duration_days?: number | null
  /** @nullable */
  campaign_expiration_date?: string | null
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country: string
}

export interface CreateCampaignResponse {
  identifier: string
  /** @nullable */
  offer_discount_id?: string | null
  offer_discount_type: BenefitType
  offer_discount_amount: number
  /** @nullable */
  reward_id?: string | null
  reward_type: BenefitType
  reward_amount: number
  /** @nullable */
  coupon_expiry_duration_days?: number | null
  /** @nullable */
  campaign_expiration_date?: string | null
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country: string
}

export type PaymentSubscriptionProductType =
  (typeof PaymentSubscriptionProductType)[keyof typeof PaymentSubscriptionProductType]

export const PaymentSubscriptionProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export interface PriceBreakdown {
  total: number
  subtotal: number
  shipping_total: number
  currency: string
  /** @nullable */
  amount?: number | null
}

export interface Recurring {
  interval: string
  interval_count: number
}

export interface PaymentSubscription {
  id: string
  product_type: PaymentSubscriptionProductType
  /**
   * Use priceBreakdown.total
   * @deprecated
   */
  price: number
  price_breakdown: PriceBreakdown
  recurring?: Recurring | null
}

export interface ReferralSubscriptionDto {
  subscription_details: PaymentSubscription
  is_coupon_reward_eligible: boolean
}

export interface FetchSubscriptionsResponse {
  subscriptions: ReferralSubscriptionDto[]
}

export interface BenefitDto {
  promo_code?: BenefitPromotionCode | null
  amount: number
  benefit_type: BenefitType
  /** @nullable */
  redeemed_at?: string | null
}

export interface FetchBenefitsResponse {
  username: string
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @nullable
   * @pattern ^[a-zA-Z]{2}$
   */
  country?: string | null
  total_referrals_count: number
  available_benefits: BenefitDto[]
  redeemed_benefits: BenefitDto[]
}

export interface ErrorResponseDefinition {
  message: string
  path: string
  timestamp: string
  status: number
  /** @nullable */
  trace?: string | null
  error: string
}

export type GetStatusForCampaignResponseStatus =
  (typeof GetStatusForCampaignResponseStatus)[keyof typeof GetStatusForCampaignResponseStatus]

export const GetStatusForCampaignResponseStatus = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
} as const

export interface GetStatusForCampaignResponse {
  identifier: string
  status: GetStatusForCampaignResponseStatus
  offer_discount_type: BenefitType
  offer_discount_amount: number
  reward_type: BenefitType
  reward_amount: number
  country: string
}

export interface CampaignDto {
  identifier: string
  offer_discount_amount: number
  offer_discount_type: BenefitType
  reward_amount: number
  reward_type: BenefitType
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country: string
}

export interface CampaignRecord {
  /** @nullable */
  id?: string | null
  created_at: string
  updated_at: string
  identifier: string
  /** @nullable */
  offer_discount_id?: string | null
  offer_discount_type: BenefitType
  offer_discount_amount: number
  /** @nullable */
  reward_id?: string | null
  reward_amount: number
  reward_type: BenefitType
  /** @nullable */
  coupon_expiry_duration_days?: number | null
  /** @nullable */
  campaign_expiration_date?: string | null
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country: string
  campaign_reward_id: string
}

export type PrivateRedeemReferrerPromoCodeParams = {
  referrerUsername: string
}

export type PrivateGetReferrerSubscriptionsParams = {
  referrerUsername: string
}

export type PrivateGetReferrerRewardsParams = {
  referrerUsername: string
}

export type PrivateGetEligibleCampaignForUserParams = {
  username: string
}

export const getReferralServiceClient = (axiosInstance: AxiosInstance = axios) => {
  /**
   * This endpoint will apply a promo code to a subscription. If the subscription is PROGRAM and less than £10 a month, itwill create a new promo code of the same value but spread over multiple months.
   * @summary Redeem referrer promo code on their subscription.
   */
  const redeemReferrerPromoCode = (
    subscriptionId: string,
    redeemPromoCodeRequest: RedeemPromoCodeRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.put(
      `/public/referrals/subscriptions/${subscriptionId}/redeem-promo-code`,
      redeemPromoCodeRequest,
      options,
    )
  }

  /**
   * This endpoint will apply a promo code to a subscription. If the subscription is PROGRAM and less than £10 a month, itwill create a new promo code of the same value but spread over multiple months.
   * @summary Redeem referrer promo code on their subscription.
   */
  const privateRedeemReferrerPromoCode = (
    subscriptionId: string,
    redeemPromoCodeRequest: RedeemPromoCodeRequest,
    params: PrivateRedeemReferrerPromoCodeParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.put(
      `/private/referrals/subscriptions/${subscriptionId}/redeem-promo-code`,
      redeemPromoCodeRequest,
      {
        ...options,
        params: { ...params, ...options?.params },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
      },
    )
  }

  /**
   * This endpoint will create the unique promo code associated to the referee, store it in the DB, and send an email to them.
   * @summary Referee signup into the referral scheme.
   */
  const refereeSignedUp = (
    refereeSignupRequest: RefereeSignupRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<RefereeSignupResponse>> => {
    return axiosInstance.post(`/public/referrals/referee-signup`, refereeSignupRequest, options)
  }

  /**
   * @summary Create a campaign.
   */
  const privateCreateCampaign = (
    createCampaignRequest: CreateCampaignRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CreateCampaignResponse>> => {
    return axiosInstance.post(`/private/campaigns`, createCampaignRequest, options)
  }

  /**
   * @summary Fetches referrer subscriptions and whether a promo code can be applied to it.
   */
  const getReferrerSubscriptions = (
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<FetchSubscriptionsResponse>> => {
    return axiosInstance.get(`/public/referrals/subscriptions`, options)
  }

  /**
   * @summary Fetches referrer rewards earned by referee purchases.
   */
  const getReferrerRewards = (options?: AxiosRequestConfig): Promise<AxiosResponse<FetchBenefitsResponse>> => {
    return axiosInstance.get(`/public/referrals/rewards`, options)
  }

  /**
   * @summary Get status for campaign matching the identifier.
   */
  const getStatusForCampaign = (
    identifier: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GetStatusForCampaignResponse>> => {
    return axiosInstance.get(`/public/campaigns/${identifier}/status`, options)
  }

  /**
   * @summary Get oldest campaign a user is eligible for.
   */
  const getEligibleCampaignForUser = (options?: AxiosRequestConfig): Promise<AxiosResponse<CampaignDto>> => {
    return axiosInstance.get(`/public/campaigns/eligibility`, options)
  }

  /**
   * @summary Fetches referrer subscriptions and whether a promo code can be applied to it.
   */
  const privateGetReferrerSubscriptions = (
    params: PrivateGetReferrerSubscriptionsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<FetchSubscriptionsResponse>> => {
    return axiosInstance.get(`/private/referrals/subscriptions`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Fetches referrer rewards earned by referee purchases.
   */
  const privateGetReferrerRewards = (
    params: PrivateGetReferrerRewardsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<FetchBenefitsResponse>> => {
    return axiosInstance.get(`/private/referrals/rewards`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Get campaign matching the identifier.
   */
  const privateGetCampaign = (
    identifier: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CampaignRecord>> => {
    return axiosInstance.get(`/private/campaigns/${identifier}`, options)
  }

  /**
   * @summary Delete a campaign
   */
  const privateDeleteCampaign = (identifier: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(`/private/campaigns/${identifier}`, options)
  }

  /**
   * @summary Get oldest campaign a user is eligible for.
   */
  const privateGetEligibleCampaignForUser = (
    params: PrivateGetEligibleCampaignForUserParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CampaignDto>> => {
    return axiosInstance.get(`/private/campaigns/eligibility`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  return {
    redeemReferrerPromoCode,
    privateRedeemReferrerPromoCode,
    refereeSignedUp,
    privateCreateCampaign,
    getReferrerSubscriptions,
    getReferrerRewards,
    getStatusForCampaign,
    getEligibleCampaignForUser,
    privateGetReferrerSubscriptions,
    privateGetReferrerRewards,
    privateGetCampaign,
    privateDeleteCampaign,
    privateGetEligibleCampaignForUser,
  }
}
export type RedeemReferrerPromoCodeResult = AxiosResponse<void>
export type PrivateRedeemReferrerPromoCodeResult = AxiosResponse<void>
export type RefereeSignedUpResult = AxiosResponse<RefereeSignupResponse>
export type PrivateCreateCampaignResult = AxiosResponse<CreateCampaignResponse>
export type GetReferrerSubscriptionsResult = AxiosResponse<FetchSubscriptionsResponse>
export type GetReferrerRewardsResult = AxiosResponse<FetchBenefitsResponse>
export type GetStatusForCampaignResult = AxiosResponse<GetStatusForCampaignResponse>
export type GetEligibleCampaignForUserResult = AxiosResponse<CampaignDto>
export type PrivateGetReferrerSubscriptionsResult = AxiosResponse<FetchSubscriptionsResponse>
export type PrivateGetReferrerRewardsResult = AxiosResponse<FetchBenefitsResponse>
export type PrivateGetCampaignResult = AxiosResponse<CampaignRecord>
export type PrivateDeleteCampaignResult = AxiosResponse<void>
export type PrivateGetEligibleCampaignForUserResult = AxiosResponse<CampaignDto>
